import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../RelatedContactList.styled";

const ContactJob = (props) => {
  const { t, data, status } = props;

  return (
    <>
      {!!status && <DivBackgroundFullOpacity>{data}</DivBackgroundFullOpacity>}
      {!status && <DivBackgroundLowOpacity>{data}</DivBackgroundLowOpacity>}
    </>
  );
};

ContactJob.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ContactJob);
